module.exports = __webpack_public_path__ + "03bbeb3cc97cb794ee0783d032ba203f.MP3";